import { createContext, useContext, useState, useEffect } from "react";
import { getUserFromBD, subscribeToAuthChanges } from "../controllers/AccountConnectionLayer";

const AuthContext = createContext();

export const AuthProvider = ({children}) => {
    const [user, setUser] = useState(null);

    useEffect(() => {
        const getUser = async () => {
            const user = await getUserFromBD();
            setUser(user);
        };

        getUser();
        const unsubscribe = subscribeToAuthChanges(setUser);

        return () => unsubscribe();
    }, []);

    const resetUser = () => {
        setUser(null);
      };

    return (
        <AuthContext.Provider value={{user, resetUser}}>
           {children} 
        </AuthContext.Provider>
    );
};

export const useAuth = () => useContext(AuthContext);